import Vue from 'vue'
import SPColumn from './components/SPColumn'
import SPContainer from './components/SPContainer'
import SPRow from './components/SPRow'
import './styles/lib.scss'

const Components = {
    SPColumn,
    SPContainer,
    SPRow
}

Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name])
})

export default Components



// WEBPACK FOOTER //
// ./src/lib.js